// extracted by mini-css-extract-plugin
module.exports = {"search__result":"SearchResult_search__result__47ts_"};